import "core-js/modules/es.function.name.js";
export default {
  name: 'ThemeToggle',
  setup: function setup() {
    var theme = ref('theme-light');
    var bodyElement = document.querySelector('body');
    return {
      theme: theme,
      bodyElement: bodyElement
    };
  },
  props: {
    showText: {
      default: true,
      required: false,
      type: Boolean
    }
  },
  computed: {
    /**
     * Check whether localStorage is both supported and available.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#testing_for_availability
     */
    localStorageIsAvailable: function localStorageIsAvailable() {
      var storage;

      try {
        storage = window['localStorage'];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
      } catch (e) {
        return e instanceof DOMException && ( // everything except Firefox
        e.code === 22 || // Firefox
        e.code === 1014 || // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' || // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
        storage && storage.length !== 0;
      }
    }
  },
  created: function created() {
    if (this.localStorageIsAvailable) {
      this.theme = localStorage.getItem('theme') || 'theme-light';
    }

    this.$store.dispatch('setTheme', this.theme);
    this.bodyElement.classList.add('content-wrapper');
    this.bodyElement.classList.add(this.theme);
  },
  methods: {
    toggleTheme: function toggleTheme() {
      if (this.theme === 'theme-light') {
        this.bodyElement.classList.remove('theme-light');
        this.theme = 'theme-dark';
        this.bodyElement.classList.add(this.theme);
      } else {
        this.bodyElement.classList.remove('theme-dark');
        this.theme = 'theme-light';
        this.bodyElement.classList.add(this.theme);
      }

      localStorage.setItem('theme', this.theme);
      this.$store.dispatch('setTheme', this.theme);
    }
  }
};